import { render, staticRenderFns } from "./channel_banner.vue?vue&type=template&id=79c85c42&scoped=true&"
import script from "./channel_banner.vue?vue&type=script&lang=js&"
export * from "./channel_banner.vue?vue&type=script&lang=js&"
import style0 from "./channel_banner.vue?vue&type=style&index=0&id=79c85c42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c85c42",
  null
  
)

export default component.exports